import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetNewsListFailed, EGetNewsListActionType } from './types';

export const getNewsListFailed: () => TGetNewsListFailed = actionGenerator<EGetNewsListActionType.Failed>(
  EGetNewsListActionType.Failed,
);
